import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class InsuranceInfoCoverageStatus extends Fragment {
  @attr('string') type;
  @attr('moment') date;
}
